/* <bip-pack-picker>: pack radio cards (+ optional add-on switch for option 2) that drive Aurora's own
 * <variant-picker> in the same section. Aurora then updates price, URL (?variant=), the form's id input and media.
 * Fallback (no Aurora picker found): set the form's id input + URL ourselves. */
(function () {
  if (!window.customElements || customElements.get('bip-pack-picker')) return;

  class BipPackPicker extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var scope = this.closest('.shopify-section') || document;
      this.aurora = scope.querySelector('variant-picker');
      this.form = scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('form[action*="/cart/add"]');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('.bip-pack__radio'));
      this.addon = this.querySelector('[data-bip-addon]');
      this.addonInput = this.querySelector('[data-bip-addon-input]');
      var self = this;
      this.radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) self.apply(); }); });
      if (this.addonInput) this.addonInput.addEventListener('change', function () { self.apply(); });
      var tipBtn = this.querySelector('[data-bip-tip-btn]'), tip = this.querySelector('[data-bip-tip]');
      if (tipBtn && tip) {
        var place = function () { // keep the bubble inside the viewport (8px margin) on any width
          tip.style.translate = '0px 0px';
          // bounds = the picker's own column (Aurora clips overflow there) and the viewport
          var r = tip.getBoundingClientRect(), box = self.getBoundingClientRect(), vw = document.documentElement.clientWidth, dx = 0;
          var minX = Math.max(8, box.left), maxX = Math.min(vw - 8, box.right);
          if (r.right > maxX) dx = maxX - r.right;
          if (r.left + dx < minX) dx = minX - r.left;
          tip.style.translate = dx + 'px 0px';
        };
        var setTip = function (open) { tip.classList.toggle('is-open', open); tipBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) place(); };
        tipBtn.addEventListener('mouseenter', place);
        tipBtn.addEventListener('focus', place);
        tipBtn.addEventListener('click', function (e) { e.preventDefault(); setTip(!tip.classList.contains('is-open')); });
        tipBtn.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setTip(false); tip.classList.add('is-dismissed'); } });
        tipBtn.addEventListener('blur', function () { setTip(false); tip.classList.remove('is-dismissed'); });
        tipBtn.addEventListener('mouseleave', function () { tip.classList.remove('is-dismissed'); });
        document.addEventListener('click', function (e) { if (!tipBtn.contains(e.target)) setTip(false); });
      }
      if (this.aurora) this.aurora.setAttribute('inert', ''); // hidden by CSS; keep it out of tab order too
      this._poll = setInterval(this.syncFromForm.bind(this), 500);
      this.paint();
    }

    disconnectedCallback() { clearInterval(this._poll); this._init = false; }

    state() { return this.addonInput && this.addonInput.checked ? 1 : 0; }

    current() {
      var r = this.radios.filter(function (x) { return x.checked; })[0];
      if (!r) return null;
      var card = r.closest('.bip-pack__card');
      var tpl = card.querySelector('template[data-state="' + this.state() + '"]') || card.querySelector('template[data-state="0"]');
      return { radio: r, card: card, tpl: tpl };
    }

    apply() {
      var cur = this.current(); if (!cur) return;
      var options = [cur.radio.value];
      if (this.addon) options.push(this.state() ? this.addon.dataset.on : this.addon.dataset.off);
      var drove = false;
      var scope = this.closest('.shopify-section') || document;
      this.aurora = scope.querySelector('variant-picker') || this.aurora; // Aurora may re-render it
      if (this.aurora && !this.aurora.hasAttribute('inert')) this.aurora.setAttribute('inert', '');
      if (this.aurora) {
        var groups = this.aurora.querySelectorAll('[data-variant-picker-option-inputs]');
        var last = null;
        options.forEach(function (val, i) {
          var g = groups[i]; if (!g) return;
          var inputs = g.querySelectorAll('input');
          for (var k = 0; k < inputs.length; k++) {
            if (inputs[k].value === val) { if (!inputs[k].checked) { inputs[k].checked = true; last = inputs[k]; } break; }
          }
        });
        if (last) { last.dispatchEvent(new Event('change', { bubbles: true })); drove = true; }
        else if (groups.length) drove = true; // already selected
      }
      if (!drove && this.idInput && cur.tpl) {
        var id = cur.tpl.dataset.variant;
        this.idInput.value = id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        try { var u = new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      this.paint();
    }

    syncFromForm() {
      if (!this.idInput) return;
      var id = String(this.idInput.value);
      if (id === this._lastId) return;
      this._lastId = id;
      var self = this;
      this.radios.forEach(function (r) {
        var card = r.closest('.bip-pack__card');
        var t = card.querySelector('template[data-variant="' + id + '"]');
        if (t) {
          r.checked = true;
          if (self.addonInput) self.addonInput.checked = t.dataset.state === '1';
        }
      });
      this.paint();
    }

    paint() {
      var st = this.state(), sel = null;
      this.radios.forEach(function (r) {
        var card = r.closest('.bip-pack__card');
        card.classList.toggle('is-selected', r.checked);
        if (r.checked) sel = card;
        var t = card.querySelector('template[data-state="' + st + '"]') || card.querySelector('template[data-state="0"]');
        if (!t) return;
        var d = t.dataset;
        var now = card.querySelector('[data-bip-now]'); if (now) now.textContent = d.price;
        var was = card.querySelector('[data-bip-was]'), wasA = card.querySelector('[data-bip-was-amount]');
        if (was) { was.hidden = !d.compare; if (wasA) wasA.textContent = d.compare || ''; }
        var save = card.querySelector('[data-bip-save]'); if (save) { save.textContent = d.save || ''; save.hidden = !d.save; }
        var unit = card.querySelector('[data-bip-unit]'); if (unit) unit.textContent = d.unit;
      });
      if (this.addon && sel) {
        var on = sel.querySelector('template[data-state="1"]');
        this.addon.hidden = !on;
        if (on) {
          var u = this.addon.querySelector('[data-bip-addon-unit]'); if (u) u.textContent = on.dataset.addonUnit;
        }
      }
    }
  }

  customElements.define('bip-pack-picker', BipPackPicker);
})();
